
import * as defaultImport from "@splunk/react-icons/Diamond";
export * from "@splunk/react-icons/Diamond";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
